import React from 'react'

export const CorreoInscripcion = (props) => {
    if(props.idioma === 'es'){
        return (
            <div>
                <h3>Formulario de creación de cliente</h3>
                <p>Estimado socio valioso, nos complace tenerlo como nuevo cliente.</p>
    
                <p>Para proceder con la inscripción de su cuenta, le pedimos amablemente que complete lo siguiente:</p>
                <p>Por favor, complete el formulario en línea disponible en el siguiente enlace: </p>
        
                <a
                 href={`${process.env.REACT_APP_PUBLIC_URL}/inscripcionClientes/${props.idioma}/${props?.enlace}`} 
                 target='_blank' rel="noreferrer" >Has click aquí para ingresar al formulario.</a>
    
                <p>Asegúrese de que todos los documentos solicitados sean claros y legibles antes de adjuntarlos al formulario.</p>

                <p>Si tiene alguna pregunta o necesita asistencia, no dude en contactarnos al correo electrónico ap@ppf.com.hn o a su agente de servicio al cliente.</p>

                <p>Gracias por su cooperación, confiamos en que juntos lograremos grandes éxitos.</p>
    
            </div>
        )
    }else{
        return (
            <div>
                <h3>Customer creation form</h3>

                <p>Dear Valued partner, we are delighted to have you as a new customer.</p>
    
                <p>To proceed with setting up your account, we kindly ask that you complete the following:</p>
                <p>Please fill out the online form available at the following link:</p>
        
                <a
                 href={`${process.env.REACT_APP_PUBLIC_URL}/inscripcionClientes/${props.idioma}/${props?.enlace}`} 
                 target='_blank' rel="noreferrer" >Click here to enter the form.</a>
    
                <p>Ensure that all documents are clear and legible before attaching them to the form. </p>
                
                <p>If you have any questions or need assistance, please do not hesitate to contact us at the e-mail ap@ppf.com.hn and to your customer service agent.</p>

                <p>Thank you for your cooperation. We look forward to a successful partnership with you.</p>
    
            </div>
        )
    }
}